export const evidenceQnCodeRegex = new RegExp('.*E\\d+', 'g');
